import { PureComponent } from 'react';
import type { ReactNode } from 'react';
import track from 'react-tracking';
import { HelpButton } from './styled';
import HelpModal from '../HelpModal';
import { InformationSolid } from '@simplywallst/ui-core/icons';

interface State {
  visible: boolean;
}

export interface Props {
  cyId?: string;
  title?: string;
  companyId: string;
  children: ReactNode;
}

@track({
  type: 'track',
})
class Help extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { visible: false };
  }

  componentDidUpdate(prevProps: Props) {
    const { closeRawDataModal } = this;
    const { companyId: prevCompanyId } = prevProps;
    const { companyId: nextCompanyId } = this.props;
    if (prevCompanyId !== nextCompanyId) {
      closeRawDataModal();
    }
  }

  @track({
    action: 'click',
    modifier: 'help',
  })
  openRawDataModal = () => {
    this.setState({ visible: true });
  };

  closeRawDataModal = () => {
    this.setState({ visible: false });
  };

  render() {
    const { openRawDataModal, closeRawDataModal } = this;
    const { visible } = this.state;
    const { cyId, title, children } = this.props;
    return (
      <>
        <HelpButton
          data-cy-id={cyId || 'help'}
          styleType="gentle"
          marginRight
          alignIcon="left"
          onClick={openRawDataModal}
        >
          <InformationSolid />
          Help
        </HelpButton>
        <HelpModal
          title={title}
          onClose={closeRawDataModal}
          isVisible={visible}
        >
          {children}
        </HelpModal>
      </>
    );
  }
}

export default Help;
